<template>
  <div class="report-filter" :key="updateKey">
    <!-- Toggler -->
    <div class="toggler">
      <div class="left">
        <input :checked="isFilterEnabled"
               @change="toggleFilter(filterKey)"
            type="checkbox">
      </div>
      <div class="right">
        <a href="#" @click.prevent="toggleFilter(filterKey)"><b>Tags</b></a>
      </div>
    </div>
    <!-- / Toggler -->

    <!-- Options -->
    <div class="options" v-if="isFilterEnabled">
<!--      {{ filtersEnabled }}-->
      <v-select :options="tagTemplates" label="name" multiple
                :reduce="tag => tag.name"
                :disabled="isLoadingTagTemplates"
                @option:selected="incrementUpdateKey"
                @option:deselected="incrementUpdateKey"
      :value="params['tags']" @input="setTagFilter"></v-select>
    </div>
    <!-- / Options -->
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Tickets from "../../../../../mixins/Tickets";
import axios from 'axios';

export default {
  name: "PriorityFilter",
  mixins: [Tickets],
  data() {
    return {
      filterKey: 'tags',
      updateKey: 1,

      isLoadingTagTemplates: false,
      tagTemplates: []
    }
  },
  created() {
      this.loadTagTemplates();
  },
  methods: {
    ...mapActions('reportEditor', {
      toggleFilter: 'toggleFilter',
      setTagFilter: 'setTagFilter'
    }),

    incrementUpdateKey() {
      this.updateKey += 1;
    },

    loadTagTemplates() {
        let vm = this;
        vm.isLoadingTagTemplates = true;
        axios.get(window.API_BASE + '/tag-templates').then(r => {
            vm.isLoadingTagTemplates = false;
            vm.tagTemplates = r.data;
        }).catch(e => {
            console.log(e);
            vm.isLoadingTagTemplates = false;
            vm.tagTemplates = [];
        }); 
    }
  },
  computed: {
    ...mapGetters('reportEditor', {
      filtersEnabled: 'filtersEnabled',
      params: 'params'
    }),

    isFilterEnabled() {
      return this.filtersEnabled.includes(this.filterKey);
    }
  }
}
</script>

<style lang="scss" scoped>
.report-filter {
  background: #fff;
  border-radius: 5px;
  padding: 13px 15px;
  margin-bottom: 15px;

  .toggler {
    display: flex;
    flex-direction: row;
    align-items: center;

    .left {
      flex-shrink: 1;
      padding-top: 4px;
      padding-right: 15px;
    }

    .right {
      flex: 1;
      font-weight: 600;
      color: #2c5cc5;
    }
  }

  .options {
    margin-top: 10px;
  }
}
</style>